import { Row, Col } from 'react-bootstrap';
import React, { useState } from 'react';
import { Form, Button, Table } from 'react-bootstrap';
import he from 'he'; 

export default function NovaSolicitacao() {
    const [solicitacao, setSolicitacao] = useState(null);
    const [consultas, setConsultas] = useState([]);
    const [protocolo, setProcolo] = useState("");
    const [buscaRealizada, setBuscaRealizada] = useState(false);

    const formatDateAsDMY = (dataObject) => {
        // Make sure we have a valid object with a .date field
        if (!dataObject || !dataObject.date) return "";
        const date = new Date(dataObject.date);
        const day = date.getDate();
        const month = date.getMonth() + 1;
        const year = date.getFullYear();
        const dd = day < 10 ? `0${day}` : `${day}`;
        const mm = month < 10 ? `0${month}` : `${month}`;
        return `${dd}/${mm}/${year}`;
    };

    const decodeText = (text) => decodeURIComponent(escape(text));

    /**
     * Tenta decodificar um texto que pode vir:
     * - percent-encoded (URL-encoded)
     * - com entidades HTML
     * - ou já legível
     */
    const decodeAnyText = (text) => {
        if (!text) return '';

        let decoded = text;

        // 1) Verificar se o texto parece percent-encoded:
        // Se tiver muitos %, pode ser URL encoded
        const pctEncoded = /%[0-9A-Fa-f]{2}/.test(decoded);
        if (pctEncoded) {
            try {
                decoded = decodeURIComponent(decoded);
            } catch (e) {
                console.warn('Erro ao decodificar URL:', e);
                // Continua com o texto original mesmo assim
            }
        }

        // 2) Verificar se tem entidades HTML e decodificar
        decoded = he.decode(decoded);

        return decoded;
    };


    const handleSubmit = (e) => {
        e.preventDefault();
        fetch(`https://www.alepe.pe.gov.br/servicos/transparencia/acompanhar-sic.php?hash_sic=${protocolo}`)
            .then(res => res.json())
            .then(jsonResult => {
                setSolicitacao(jsonResult.resultado);
                setConsultas(jsonResult.consultas || []);
                setBuscaRealizada(true);
            })
            .catch(() => {
                setSolicitacao(null);
                setConsultas([]);
                setBuscaRealizada(true);
            });
    };

    return (
        <Row>
            <Col xs="12">
                <p><small>Você está em <a href="/ouvidoria">SISTEMA DE INFORMAÇÃO AO CIDADÃO E OUVIDORIA</a> / Acompanhamento</small></p>
            </Col>

            <Col sm={12}>
                <h1>Acompanhamento de Solicitação</h1>
                <Form onSubmit={handleSubmit}>
                    <Form.Group controlId="protocolo">
                        <Form.Label>Informe o número do protocolo</Form.Label>
                        <Form.Control
                            type="text"
                            name="protocolo"
                            onChange={e => setProcolo(e.target.value)}
                            value={protocolo}
                            required
                        />
                    </Form.Group>
                    <Row>
                        <Col xs={12} className="text-end mt-4">
                            <Button className="button" type="submit">
                                Buscar
                            </Button>
                        </Col>
                    </Row>
                </Form>
            </Col>

            {solicitacao && (
                <Col sm={12}>
                    <h3>Resultado</h3>
                    <Form>
                        <div>
                            {solicitacao.solicitante !== 'ANONIMO' && (
                                <div id="dadosUsuario">
                                    <Form.Group>
                                        <Form.Label>Nome</Form.Label>
                                        <Form.Control type="text" value={solicitacao.solicitante} readOnly />
                                    </Form.Group>
                                    <Form.Group>
                                        <Form.Label>{solicitacao.tipo_identificacao}:</Form.Label>
                                        <Form.Control type="text" value={solicitacao.numero_identificacao} readOnly />
                                    </Form.Group>
                                    <Form.Group>
                                        <Form.Label>Endereço</Form.Label>
                                        <Form.Control type="text" value={solicitacao.logradouro} readOnly />
                                    </Form.Group>
                                    <Form.Group>
                                        <Form.Label>Bairro</Form.Label>
                                        <Form.Control type="text" value={solicitacao.bairro} readOnly />
                                    </Form.Group>
                                    <Form.Group>
                                        <Form.Label>Telefone</Form.Label>
                                        <Form.Control type="text" value={solicitacao.telefone} readOnly />
                                    </Form.Group>
                                </div>
                            )}

                            <Form.Group>
                                <Form.Label>Solicitação:</Form.Label>
                                <Form.Control
                                    as="textarea"
                                    className="inputMsg"
                                    value={decodeAnyText(solicitacao.detalhamento_solicitacao)}
                                    readOnly
                                />
                            </Form.Group>

                            <div className="proposicao-list">
                                <div className="proposicao-list-item titulo-search" style={{ marginTop: '30px' }}>
                                    <h3 className="title">Status</h3>
                                </div>

                                {consultas.length > 0 ? (
                                    <Table className="table">
                                        <thead>
                                            <tr>
                                                <th>Data</th>
                                                <th>Setor</th>
                                                <th>Situação</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {consultas.map((c, i) => (
                                                <tr key={i}>
                                                    <td>{formatDateAsDMY(c.dataconsulta)}</td>
                                                    <td>{c.setorconsultado}</td>
                                                    <td>{c.situacao}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </Table>
                                ) : (
                                    <Form.Control
                                        type="text"
                                        value="Ainda não há resposta oficial/definitiva para esta consulta."
                                        readOnly
                                    />
                                )}
                            </div>
                        </div>
                    </Form>
                </Col>
            )}

            {buscaRealizada && !solicitacao && (
                <Col sm={12}>
                    <h3>Solicitação não encontrada.</h3>
                </Col>
            )}

            <Col sm={12} className="mt-5">
                <h5>SIC - SERVIÇO DE INFORMAÇÃO AO CIDADÃO</h5>
                <p>Deseja fazer o pedido de acesso à informação presencialmente?</p>
                <p>É só dirigir-se ao endereço físico do SIC da Assembleia Legislativa de Pernambuco:</p>
                <p>
                    Rua da União, 397, Boa Vista, Recife‑PE, Anexo I, 6º Andar, Sala 603.<br />
                    CEP: 50050‑909<br />
                    Fone: (81) 3183‑2211<br />
                    Ramal: 2003
                </p>
                <p>Horário de funcionamento: segunda a quinta 8h–12h & 14h–18h; sexta 8h–13h</p>
            </Col>
        </Row>
    );
}
